/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import * as R from 'ramda'
import { TRACKING_STRINGS } from '../../constants/globalStrings'
import { pathFinder } from './pageViews'

// gets the last path item providing there is no trailing slash
const getLast = (path) => {
  const split = path.split('/')
  return split[split.length - 1]
}

// to be used for any baths that use a pattern with many generated outcomes
// e.g roaming pages with all the countries
// key needs to be a regex
// value needs to be a function that accepts the full path which returns the full event
export const dynamicPaths = new Map([
  [
    new RegExp(/^\/roaming\/europe\/[\w]/),
    (path) => ({
      name: `roaming.europe.${getLast(path)}`,
      type: 'support-help',
    }),
  ],
  [
    new RegExp(/^\/roaming\/international\/[\w]/),
    (path) => ({
      name: `roaming.international.${getLast(path)}`,
      type: 'support-help',
    }),
  ],
  [
    new RegExp(/^\/calling-abroad\/countries\/[\w]/),
    (path) => ({
      name: `calling-abroad.countries.${getLast(path)}`,
      type: 'support-help',
    }),
  ],
  // product details pages
  [
    new RegExp(/^\/plans\/[\w-]+/),
    (path) => ({
      name: `plans-${getLast(path)}`,
      type: 'product-details',
    }),
  ],
])

const buildUser = () => {
  const state = JSON.parse(localStorage.getItem('state'))
  if (state && state.auth && state.auth.jwt && state.actingAs !== null) {
    return {
      status: 'logged-in',
      customer: {
        id: state.customerId,
        plan: state.customerPlan,
        actingAs: state.actingAs,
      },
    }
  } else if (state && state.auth && state.auth.jwt) {
    return {
      status: 'logged-in',
      customer: {
        id: state.customerId,
        plan: state.customerPlan,
      },
    }
  }
  return {
    status: 'logged-out',
  }
}

export const setDmpgObject = () => {
  if (!window.smDl) {
    window.smDl = {}
    window.smDl.events = []
  }
  window.smDl.user = buildUser()
  window.smDl.screen = getScreenFromLocation()
  buildEventsBasedOnScreenType(window.smDl.screen || {}, window.smDl, document)
  attachAllClickEvents(document, window.smDl)
}

const elements = (parent, selector) =>
  Array.from(parent.querySelectorAll(selector))

const element = (parent, selector) => parent.querySelector(selector)

const toObjectValue = ([name, value]) => {
  const keys = name.split('_')
  return keys.reverse().reduce((acc, key) => ({ [key]: acc }), value)
}

export const convertDataAttributeToObjects = (el) =>
  Object.entries(el.dataset).reduce(
    (acc, val) => R.mergeDeepLeft(acc, toObjectValue(val)),
    {}
  )

const buildItem = (el) => ({
  id: el.dataset?.itemId,
  type: el.getAttribute('data-type'),
  position: el.getAttribute('data-position'),
})

const findItem = (module, slug) =>
  elements(module, `[data-item-id="${slug}"]`).map(buildItem)

export const findModules = (parentEl = document, slug, moduleId) =>
  elements(
    parentEl,
    moduleId ? `[data-module-id="${moduleId}"]` : '[data-module-id]'
  ).map((el) => ({
    ...convertDataAttributeToObjects(el).module,
    id: el.getAttribute('data-module-id'),
    items: findItem(el, slug),
  }))

const buildItemWithAssetData = (el) => {
  const { asset, type, discount } = convertDataAttributeToObjects(el)
  return {
    ...asset,
    ...buildDiscount(discount),
    type,
    id: el.getAttribute('data-item-id'),
  }
}

export const findAssets = (parentEl = document, slug) =>
  elements(parentEl, `[data-item-id="${slug}"]`)
    .map(buildItemWithAssetData)
    .reduce((acc, item) => {
      if (!acc[item.type]) {
        acc[item.type] = []
      }
      acc[item.type].push(R.omit(['type'], item))
      return acc
    }, {})

export const findProducts = (parentEl = document) =>
  elements(parentEl, '[data-product_id]')
    .map(convertDataAttributeToObjects)
    .map(({ product }) => product)

const buildDiscount = (discount) => {
  if (discount) {
    return { discount: { lines: [discount] } }
  }
  return undefined
}

const buildCart = (parentEl) => {
  const cartEl = element(parentEl, '[data-cart_checkout-step]')
  if (cartEl) {
    const { cart } = convertDataAttributeToObjects(cartEl)

    const productLines = elements(parentEl, '[data-lines_id]')
      .map(convertDataAttributeToObjects)
      .map(({ lines, discount }) => ({
        product: lines,
        ...buildDiscount(discount),
      }))

    return { ...cart, lines: productLines }
  }

  return undefined
}

const buildTransaction = (parentEl) => {
  const transactionEl = element(parentEl, '[data-transaction_id]')
  if (transactionEl) {
    const { transaction } = convertDataAttributeToObjects(transactionEl)
    return transaction
  }

  return undefined
}

export const moduleEvent = (container, slug, moduleId) => ({
  event: TRACKING_STRINGS.MODULE_LOAD,
  modules: findModules(container, slug, moduleId),
  assets: findAssets(container, slug),
})

const screenEvent = ({ screen, user }) => ({
  event: TRACKING_STRINGS.SCREEN_LOAD,
  screen,
  user,
})

// const removeIfArrayEmpty = (event, arrayName) => {
//   if (event[arrayName].length > 0) {
//     return event
//   }
//   return undefined
// }

const compact = (array) => array.filter((value) => value !== undefined)

const buildEventsBasedOnScreenType = ({ type, name }, dl, container) => {
  let events

  // commenting below set of code- as we are not loading any module event on initial page load.
  // The module event is triggered on viewport

  switch (type) {
    // case 'homepage':
    //   const valueBeforeCompact = [
    //     removeIfArrayEmpty(moduleEvent(container), 'modules'),
    //   ]
    //   const returnVal = compact(valueBeforeCompact)
    //   return returnVal
    // case 'landing-page':
    //   return compact([removeIfArrayEmpty(moduleEvent(container), 'modules')])
    case 'product-details':
      return compact([
        // removeIfArrayEmpty(moduleEvent(container), 'modules'),
      ]).concat(
        findProducts(container).map((product) => ({
          product,
          event: TRACKING_STRINGS.PRODUCT_VIEW,
        }))
      )
    case 'checkout':
      const cart = buildCart(container)
      if (name === 'plans-confirmation') {
        const transaction = buildTransaction(container)
        if (transaction && transaction.id) {
          events = [
            {
              event: TRACKING_STRINGS.TRANSACTION_SUCCESS,
              transaction: { ...transaction, cart },
            },
          ]
        } else {
          events = []
        }
      } else if (name === 'plans-2') {
        events = [
          {
            event: TRACKING_STRINGS.REGISTRATION_SUCCESS,
            user: buildUser(),
          },
        ]
        if (cart) {
          events.push({
            event: TRACKING_STRINGS.ADD_TO_CART,
            cart: buildCart(container),
          })
        }
      } else {
        events = []
        if (cart) {
          events.push({
            event: TRACKING_STRINGS.ADD_TO_CART,
            cart: buildCart(container),
          })
        }
      }
      return events
    default:
      return []
  }
}

const attachClickEvent = (
  container,
  ele,
  smdlObject,
  clickEvent = 'data-dmpg-event-name'
) =>
  (ele.onclick = () =>
    smdlObject.events.push({
      event: ele.getAttribute(clickEvent),
      ...convertDataAttributeToObjects(ele).event,
    }))

const attachAllClickEvents = (container, smdlObject) => {
  elements(container, '[data-dmpg-event-name]').forEach((el) =>
    attachClickEvent(container, el, smdlObject)
  )
  elements(container, '[data-item-id]').forEach((el) =>
    attachClickEvent(container, el, smdlObject, 'data-item-id')
  )
}

const removeTrailingSlash = (path) => {
  if (path.endsWith('/')) {
    return path.substring(0, path.length - 1)
  }
  return path
}

export const getScreenFromLocation = () => {
  const name = removeTrailingSlash(window.location.pathname)
  let dynamicEvent

  if (typeof pathFinder[name] !== 'undefined') {
    return pathFinder[name]
  }

  dynamicPaths.forEach((func, regex) => {
    if (regex.test(name)) {
      dynamicEvent = func(name)
    }
  })

  return dynamicEvent
}

const dmpgLayerNotAlreadyInitializedForThisScreen = (
  screen,
  previouslyAttachedScreen
) => screen && screen.name !== previouslyAttachedScreen

const completeInitializationForScreen = (
  completedEvents,
  smdlObject,
  container
) => {
  completedEvents.forEach((completedEvent) =>
    smdlObject.events.push(completedEvent)
  )
  attachAllClickEvents(container, smdlObject)
}

const findLastScreenEvent = (smdlObject) =>
  R.findLast(R.propEq('event', TRACKING_STRINGS.SCREEN_LOAD))(smdlObject.events)

const matchScreen = (a, b) => a.name === b.name && a.type === b.type

const addScreenEventIfItChanged = (smdlObject) => {
  const lastScreenEvent = findLastScreenEvent(smdlObject)
  if (
    !lastScreenEvent ||
    !matchScreen(smdlObject.screen, lastScreenEvent.screen)
  ) {
    smdlObject.events.push(screenEvent(smdlObject))
  }
}

const buildDmpgDataAttributeListener = (container, smdlObject, getScreen) => {
  let previouslyAttachedScreen = null
  return () => {
    smdlObject.screen = getScreen()
    smdlObject.user = buildUser()
    if (smdlObject.screen) {
      addScreenEventIfItChanged(smdlObject)
    }
    if (
      dmpgLayerNotAlreadyInitializedForThisScreen(
        smdlObject.screen,
        previouslyAttachedScreen
      )
    ) {
      const completedEvents = buildEventsBasedOnScreenType(
        smdlObject.screen,
        smdlObject,
        container
      )

      if (completedEvents.length > 0) {
        completeInitializationForScreen(completedEvents, smdlObject, container)
        previouslyAttachedScreen = smdlObject.screen.name
      }
    }
  }
}

export const attach = (
  container,
  smdlObject,
  getScreen = getScreenFromLocation
) => {
  const dmpgListener = buildDmpgDataAttributeListener(
    container,
    smdlObject,
    getScreen
  )
  const observer = new MutationObserver(dmpgListener)
  observer.observe(container, { childList: true, subtree: true })
  return observer
}

const buildForm = (el) => {
  const form = el.querySelector('form')
  if (form) {
    return {
      id: form.id,
      name: form.getAttribute('data-form-name'),
    }
  }

  return undefined
}

const eventExtras = (eventName, container) => {
  const form = buildForm(container)
  if (form) return { form }
  if (eventName === 'user.interact.auto.success.loginSuccess') {
    return { user: buildUser() }
  }
  return {}
}

export const addDmpgEvent = (eventObject, container = document) =>
  window.smDl.events.push({
    ...eventObject,
    ...eventExtras(eventObject.event, container),
  })

export const updateDmpgSmdl = (event) => {
  window.smDl?.events.push(event)
}
